export const formErrorValidationsConst = (type, t) => {
    const formErrors = {
        phone: { value: /^[67890][0-9]{8,14}$/i, message: t("Number must have 9 to 15 digits and start with 6, 7, 8, 9 or 0") },
        postalCode: { value: 5, message: t("Need to be 4 digits") },
        sms: { value: 4, message: t("Need to be 4 digits") },
        iban: { value: /^[ES]{2}\d{22}$/
            , message: t("You need to insert a valid Spanish IBAN") }
    }
    return formErrors[type];
}
